"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
/** When importing this component into a server-side rendered app, we can't use a useLayoutEffect, so we replace it with a useEffect instead
 *
 * This approach is from https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? react_1.useLayoutEffect : react_1.useEffect;
exports.default = useIsomorphicLayoutEffect;
//# sourceMappingURL=useIsomorphicLayoutEffect.js.map